(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/email/components/email-save.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/email/components/email-save.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState;
const Button = svs.ui.ReactButton;
const EmailInput = svs.ui.reactFormInputs.EmailInput;
const Form = svs.ui.reactForm.Form;
const emailStatuses = svs.myProfile.constants.emailStatuses;
const saveEmail = svs.myProfile.react.store.pdPreferences.actions.saveEmail;
const _svs$myProfile$react$ = svs.myProfile.react.store.pdPreferences.actions,
  getCustomersPreferences = _svs$myProfile$react$.getCustomersPreferences,
  setForceSaveEmail = _svs$myProfile$react$.setForceSaveEmail;
const getMessageByCode = svs.myProfile.react.shared.errorMessages.getMessageByCode;
const _svs$myProfile$react$2 = svs.myProfile.react.pages.myInformation.myInformation.emailDialogs,
  showSuccessDialog = _svs$myProfile$react$2.showSuccessDialog,
  showErrorDialog = _svs$myProfile$react$2.showErrorDialog;

const EmailSave = () => {
  const dispatch = ReactRedux.useDispatch();
  const _ReactRedux$useSelect = ReactRedux.useSelector(state => state.playerPreferences.playerPreferences),
    emailStatus = _ReactRedux$useSelect.emailStatus,
    email = _ReactRedux$useSelect.email;
  const emailBounced = emailStatus === emailStatuses.BOUNCE;
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    newEmail = _useState2[0],
    setNewEmail = _useState2[1];
  React.useEffect(() => {
    dispatch(getCustomersPreferences());
  }, [dispatch]);
  const trackEvent = saved => {
    const track = {
      category: 'My Profile',
      action: emailBounced ? 'email add' : 'email update',
      opt_label: saved ? 'Yes' : 'No'
    };
    svs.components.analytics.trackEvent(track);
  };
  const onSubmitHandler = async (e, formData, isValid) => {
    e.preventDefault();
    if (isValid) {
      const result = await dispatch(saveEmail(newEmail));
      if (RTK.isFulfilled(result)) {
        trackEvent(true);
        showSuccessDialog(newEmail);
        dispatch(setForceSaveEmail(false));
      } else {
        var _result$payload;
        const errorCode = result === null || result === void 0 || (_result$payload = result.payload) === null || _result$payload === void 0 ? void 0 : _result$payload.error;
        showErrorDialog(getMessageByCode(errorCode) || 'Någonting gick fel när epostadressen skulle sparas. Försök igen eller kontakta kundservice.');
      }
    }
  };
  return React.createElement(Form, {
    onSubmit: onSubmitHandler
  }, React.createElement("div", {
    className: "f-left relative"
  }, React.createElement(EmailInput, {
    isLessSpace: true,
    label: email ? 'Ange ny e-post' : 'Ange e-post',
    name: "email",
    onChange: e => setNewEmail(e.target.value),
    value: newEmail
  }), React.createElement(Button, {
    block: true,
    className: "margin-v-1",
    inverted: true,
    size: 300,
    type: "submit"
  }, "Spara")));
};
svs.myProfile.react.pages.myInformation.myInformation.email.EmailSave = EmailSave;

 })(window);